import { useCallback } from "react";
import { useTranslation } from "../context/TranslationContext";
import { getBootstrapGuest } from "../services/api/apiClient";

export const useGuestBootstrap = () => {
  const { dispatch: translationsDispatch } = useTranslation();
  return useCallback(async () => {
    const response = await getBootstrapGuest(window.location.origin);
    translationsDispatch({ type: "SET_ALL", payload: response.translations });
  }, [translationsDispatch]);
};
